/* global $ */
import React, { useCallback } from 'react';
import { Transition } from 'react-transition-group';
const ClassActivatingTransition = ({ activateClassName, onEnter, onExiting, ...props }) => {
    const forceReflow = useCallback(node => node.scrollTop, []);
    const handleEnter = useCallback((node, appearing) => {
        forceReflow(node);
        $(node).toggleClass(activateClassName, true);
        if (onEnter) {
            onEnter(node, appearing);
        }
    }, [activateClassName, forceReflow, onEnter]);
    const handleExiting = useCallback(node => {
        $(node).toggleClass(activateClassName, false);
        if (onExiting) {
            onExiting(node);
        }
    }, [activateClassName, onExiting]);
    return (<Transition {...props} onEnter={handleEnter} onExiting={handleExiting}/>);
};
export default ClassActivatingTransition;
